import { gsap } from 'gsap'

const TRIGGER_PX = 80 // matches --header-unit-height (4.444rem at 18px base)
const MIN_WIDTH_PX = 1200
const DURATION = 0.45
const EASE = 'power3.out'

let handler: (() => void) | null = null

export const destroyHeaderCalendarReveal = () => {
  if (handler) {
    window.removeEventListener('scroll', handler)
    window.removeEventListener('resize', handler)
    handler = null
  }
}

export const initHeaderCalendarReveal = () => {
  destroyHeaderCalendarReveal()

  const wrap = document.querySelector<HTMLElement>(
    '.header-nav__calendar-reveal'
  )
  if (!wrap) return

  const link = wrap.querySelector<HTMLElement>('.calendar-header-link')
  if (!link) return

  let visible = window.innerWidth >= MIN_WIDTH_PX && window.scrollY >= TRIGGER_PX
  gsap.set(link, { yPercent: visible ? 0 : -100 })

  const update = () => {
    const next = window.innerWidth >= MIN_WIDTH_PX && window.scrollY >= TRIGGER_PX
    if (next === visible) return
    visible = next
    gsap.killTweensOf(link)
    gsap.to(link, {
      yPercent: next ? 0 : -100,
      duration: DURATION,
      ease: EASE,
    })
  }

  handler = update
  window.addEventListener('scroll', handler, { passive: true })
  window.addEventListener('resize', handler, { passive: true })
}
